<template>
    <div v-show="isActive">
        <slot/>
    </div>
</template>

<script>

    export default {
        props: {
            id: {
                type: String,
                default: null
            },
            title: {
                type: String,
                required: true
            }
        },
        data: () => ({
            isActive: false
        }),
        computed: {
            computedId() {
                return this.id ? this.id : this.title.toLowerCase().replace(/ /g, '-');
            },
        },
        methods: {}
    }
</script>
